export function celebratePoints(root = document) {
  const template = root.querySelector("[data-points-celebration-template]");
  if (!template || !template.content) return;
  document.body.appendChild(template.content.cloneNode(true));
}
